import { useState } from "react";
import {
 FaClock,
 FaEnvelope,
 FaMapMarkerAlt,
 FaPhoneAlt,
 FaWhatsapp,
} from "react-icons/fa";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import SectionTitle from "../../components/ui/SectionTitle";
import { Input, Textarea } from "../../components/ui/Input";
import Button from "../../components/ui/Button";
import { submitContactEnquiry } from "../../services/contactService";

const initialForm = {
 name: "",
 companyName: "",
 email: "",
 phone: "",
 message: "",
};

export default function Contact() {
 const [form, setForm] = useState(initialForm);
 const [status, setStatus] = useState(null);
 const [submitting, setSubmitting] = useState(false);

 const update = (key, value) =>
  setForm((current) => ({ ...current, [key]: value }));

 const onSubmit = async (event) => {
  event.preventDefault();
  setStatus(null);
  setSubmitting(true);
  try {
   const response = await submitContactEnquiry(form);
   setStatus({
    type: "success",
    text: `Enquiry submitted. Reference: ${response.referenceId}`,
   });
   setForm(initialForm);
  } catch (error) {
   setStatus({
    type: "error",
    text: error.message || "Unable to submit enquiry.",
   });
  } finally {
   setSubmitting(false);
  }
 };

 return (
  <section className="container-pad py-12">
   <Breadcrumb items={[{ label: "Contact Us" }]} />
   <SectionTitle
    eyebrow="Contact"
    title="Talk to our EV product supply team"
    description="Send cell, BMS, charger, battery pack, machine or accessory enquiries."
   />
   <div className="grid gap-8 lg:grid-cols-[1fr_420px]">
    <form
     onSubmit={onSubmit}
     className="rounded-xl border border-line bg-white p-6 shadow-soft"
    >
     <div className="grid gap-5 md:grid-cols-2">
      <Input
       id="contactName"
       label="Name"
       value={form.name}
       onChange={(event) => update("name", event.target.value)}
       required
      />
      <Input
       id="contactCompany"
       label="Company"
       value={form.companyName}
       onChange={(event) => update("companyName", event.target.value)}
      />
      <Input
       id="contactEmail"
       label="Email"
       type="email"
       value={form.email}
       onChange={(event) => update("email", event.target.value)}
       required
      />
      <Input
       id="contactPhone"
       label="Phone"
       type="tel"
       value={form.phone}
       onChange={(event) => update("phone", event.target.value)}
       required
      />
     </div>
     <div className="mt-5">
      <Textarea
       id="contactMessage"
       label="Message"
       value={form.message}
       onChange={(event) => update("message", event.target.value)}
       required
      />
     </div>
     {status && (
      <p
       className={`mt-5 rounded-xl px-4 py-3 text-sm font-bold ${status.type === "success" ? "bg-green-50 text-success" : "bg-red-50 text-danger"}`}
      >
       {status.text}
      </p>
     )}
     <Button type="submit" className="mt-5" disabled={submitting}>
      {submitting ? "Submitting..." : "Submit Enquiry"}
     </Button>
    </form>

    <aside className="grid gap-4">
     <Info
      icon={FaMapMarkerAlt}
      title="Office Address"
      text="LKV/426, Left Side Lal Kaun, MB Road,New Delhi-110044"
     />
     <Info icon={FaEnvelope} title="Email" text="sales@mozogroup.in" />
     <Info icon={FaPhoneAlt} title="Phone" text="+91 8700338552" />
     <Info
      icon={FaClock}
      title="Business Hours"
      text="Monday to Saturday, Office Time 10:00AM to 6:30PM"
     />
     <a
      href="https://wa.me/918700338552"
      className="inline-flex items-center justify-center gap-3 rounded-xl bg-success px-5 py-4 font-semibold text-white shadow-soft transition hover:bg-green-700"
     >
      <FaWhatsapp /> WhatsApp Us
     </a>
    </aside>
   </div>

   <div className="mt-10 grid min-h-[360px] place-items-center rounded-xl border border-line bg-slate-200 text-center shadow-soft">
    <iframe
     title="Google Map Location"
     src="https://www.google.com/maps?q=28.5022717,77.2833252&z=16&output=embed"
     width="100%"
     height="360"
     style={{ border: 0 }}
     allowFullScreen
     loading="lazy"
     referrerPolicy="no-referrer-when-downgrade"
     className="w-full"
    />
   </div>
  </section>
 );
}

function Info({ icon: Icon, title, text }) {
 return (
  <div className="rounded-xl border border-line bg-white p-5 shadow-soft">
   <Icon className="text-2xl text-primary" />
   <h3 className="mt-3 font-semibold text-dark">{title}</h3>
   <p className="mt-1 leading-7 text-body">{text}</p>
  </div>
 );
}
